import type { SmithersDeviceConfig } from "@/types/smithers-device"
import type { SmithersProVenueRequest, SmithersProVenueSelection } from "@/types/provenue-instance"

export function getSmithersProVenueSelection(
  device: Pick<SmithersDeviceConfig, "requiresProVenueInstance" | "proVenueInstanceId" | "inheritedFromGlobal">,
): SmithersProVenueSelection {
  if (!device.requiresProVenueInstance) return { mode: "none" }
  if (device.inheritedFromGlobal.includes("proVenueInstanceId") || device.proVenueInstanceId === null) return { mode: "global" }
  return { mode: "instance", id: device.proVenueInstanceId }
}

export function toSmithersProVenueRequest(selection: SmithersProVenueSelection): SmithersProVenueRequest {
  if (selection.mode === "global") return { requiresProVenueInstance: true }
  if (selection.mode === "none") return { requiresProVenueInstance: false }
  if (!Number.isSafeInteger(selection.id) || selection.id < 1) {
    throw new Error("Select a valid ProVenue instance")
  }
  return { requiresProVenueInstance: true, proVenueInstanceId: selection.id }
}
